import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetStartedAnimationComponent } from './get-started-animation.component';

@NgModule({
  declarations: [GetStartedAnimationComponent],
  imports: [CommonModule],
  exports: [GetStartedAnimationComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GetStartedAnimationModule {}
